'use client'

import { useContext, useEffect } from "react"
// import { CommonListContext } from "../_config"
import {CommonListContext} from "@/util/board_config"
import ImageList from "@/components/board/image_list"
import { AuthContext } from "@/context/authContext"


import ListV2 from "@/components/board/list_v2"
import moment from "moment"
import { with_comma } from "@/util/comma"
import { useTranslations } from "next-intl"
import LocaleFormat from "@/components/etc/localeFormat"

export default function CommunityUsersPage() {
    const { list, setContent, isFirstRender, setIsFirstRender, post, fetchData, loading  } = useContext(CommonListContext)
    const { user } = useContext(AuthContext)

    const t = useTranslations("Text")

    function setfetchData() {
        const cleanUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, '', cleanUrl);

        if (typeof fetchData === 'function') fetchData();
    }

    function setContentFunc(id:number){
        //console.log("기타 설정 함수");
        setContent(id);
    }


    
    return (
        <ListV2 list={list} 
                setContent={setContent} 
                post={post}
                fetchData={fetchData}
                setIsFirstRender={setIsFirstRender}
                loading={loading}
                renderItem={(li) => (
                    <div className="contentsArea">
                        <div className="info">
                            <div className={`subject`}>
                                <div className={`flex ellipsis`}>
                                    {li?.pinned_order !== null && (
                                        <img src="/icon/pinned_icon.png"
                                            style={{ verticalAlign: "middle", marginRight: "4px" }}
                                            alt="pinned" />
                                    )}
                                    <div className={`ellipsis`}>{li.title}</div>
                                </div>
                            </div>
                            <div className={` auth`}>
                                <div className={`m-r-10`}>{t("작성자")} : {li.author_name}</div>
                                <div>{t("작성일")} : {<LocaleFormat date={li.create_dt} format="MM-DD" />}</div>
                            </div>
                        </div>
                    </div>
                )} />
    )
}
